import SectionHeader from "@/components/site/SectionHeader";
import ServiceCard from "@/components/site/ServiceCard";
import { SERVICES } from "@/lib/services";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/seo/Seo";
import { serviceSchema, breadcrumbSchema } from "@/components/seo/schema";

export default function Services() {
  return (
    <div data-testid="page-services" className="relative">
      <Seo
        title="Services — Web, App, CRM, CMS, API & AI | Equinox Systems"
        description="Equinox Systems services: custom web development, web & mobile apps, custom CRMs, CMS software, API integration, AI integration, plus the Free Custom Website Program. Nationwide remote."
        path="/services"
        schemas={[
          ...SERVICES.map((s) => serviceSchema(s.title, s.description, "/services")),
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }]),
        ]}
      />
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 eq-grid-bg" />
        <div className="eq-aurora" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <SectionHeader
            as="h1"
            eyebrow="Services"
            title="Built for businesses that want to operate smarter"
            description="Six focused practice areas, designed to scale together as your business grows."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.title} {...s} index={i} />
            ))}
          </div>

          <div className="mt-20 rounded-3xl p-10 md:p-14 glass">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div>
                <div className="text-xs uppercase tracking-widest text-blue-400">Ready to start?</div>
                <h3 className="font-display text-3xl mt-2">Pick a package, or request a custom quote.</h3>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <Link to="/packages" className="btn-primary w-full sm:w-auto justify-center" data-testid="services-view-packages-btn">View Packages <ArrowRight className="w-4 h-4" /></Link>
                <Link to="/quote" className="btn-ghost w-full sm:w-auto justify-center" data-testid="services-quote-btn">Get Custom Quote</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
